<template>
	<el-dialog title="成长记录" :visible.sync="visible" :before-close='growthStateClose' width="1000px" :close-on-click-modal="false" id="addPetView">
		<div class="view">
			<!-- 左侧展示 -->
			<div class="viewLeft">
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="类型" v-if="this.growthType == 1">
						<el-radio-group v-model="form.growthType">
							<el-radio label="1">当前记录</el-radio>
							<el-radio label="2">过往记录</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="时间" v-if="form.growthType == '2'">
						<el-date-picker v-model="form.date" type="datetime" placeholder="选择日期时间"></el-date-picker>
					</el-form-item>
					<el-form-item label="内容">
						<el-input type="textarea" v-model="form.text" style="width: 300px;" placeholder="请输入成长记录内容" resize="none"></el-input>
					</el-form-item>
					<div class="formView">
						<div style="width: 68px;text-align: right;padding: 0 12px 0 0;">上传图片</div>
						<div class="imgView">
							<div v-for="(item,index) in form.imageUrl" :key="index" class="imgItem">
								<img alt="" :src="item" v-if="form.imageUrl.length > 0" >
								<i class="el-icon-error closeBtn" v-if="form.imageUrl.length > 0" @click="handleDeleteImgClick(index)"></i>
							</div>
							<img style="width: 80px; height: 80px" src="../assets/img/uploadImg.png" @click="handleUploadClick" v-if="form.imageUrl.length < 9">
							<input type="file" ref="file" style="width: 0;height: 0;" @change="changeFile"/>
						</div>
					</div>
					<el-form-item label="活体状态">
						<el-radio-group v-model="form.status">
							<el-radio label="1">正常</el-radio>
							<el-radio label="0">异常</el-radio>
							<el-radio label="-1">亡故</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="说明">
						<el-input v-model="form.caption" style="width: 300px;" placeholder="请输入说明"></el-input>
					</el-form-item>
					<el-form-item label="饮食记录">
						<el-input v-model="form.record" style="width: 300px;" placeholder="请输入饮食记录"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="form.remark" type="textarea" style="width: 300px;" placeholder="请输入备注" resize="none"></el-input>
					</el-form-item>
				</el-form>
				<div class="com">1.每只活体每天至少检查三次。</div>
				<div class="com">2.发现异常应该由医生及时处理并做好记录。</div>
				<div class="com">3.每只宠物的饮食须规范化、细致化、健康化,可根据宠物自身的状况进行调整饮食和增加营养。</div>
				<div class="com">4.每次检查人员须签字并备注好检查的时间,精确到年月日时分</div>
				<div class="com">5.该宠物售卖或转移时,此表随宠物一起转移。</div>
			</div>
			<!-- 右侧展示 -->
			<div class="viewRight">
				<div class="siteName">请选择笼子:</div>
				<el-cascader :options="intRoom" :props="{ multiple: true, label: 'name',children: 'cages',value: 'id'}" clearable placeholder="请选择笼子" v-model="siteValue"></el-cascader>
				<template v-if="form.growthType == '1'">
					<div class="siteName" style="margin-top: 10px;" v-if="shopId == '5e9412e0b2bfbc089daerr12'">金水区店 当前区域笼子位置状态:</div>
					<div class="siteName" style="margin-top: 10px;" v-if="shopId == '5e9412e0b2bfbc089daerr14'">指挥中心 当前区域笼子位置状态:</div>
					<div class="siteName" style="margin-top: 10px;" v-if="shopId == '5e9412e0b2bfbc089daerr16'">拓展部 当前区域笼子位置状态:</div>
					<div class="siteName" style="margin-top: 10px;" v-if="shopId == '5e9412e0b2bfbc089daerr17'">线上旗舰店 当前区域笼子位置状态:</div>
					<!-- 笼子展示图 -->
					<div class="roomView">
						<div :class="item.room_id == roomId?'roomActive':'room'" v-for="(item, index) in roomList" :key="index" @click="handleRoomClick(item)">{{item.room_name}}</div>
					</div>
					<div class="cageView">
						<div class="cage" v-for="(item,index) in cageList" :key="index">
							<template v-if="item.room_id != ''">
								<div class="cageTitle">{{item.room_name}} (猫: {{item.cat?item.cat:"0"}}只, 犬: {{item.dog?item.dog:'0'}}只)</div>
								<div class="cageItem" v-for="(cageItem,cageIndex) in item.cage_info" :key="cageIndex">
									<div>{{cageItem.cage_name}}</div>
									<div class="petNum" v-if="cageItem.pet_list.length == 0">空</div>
									<template v-else>
										<div class="petNum">
											<span v-if="cageItem.dogCount">犬:{{cageItem.dogCount}}只</span>
											<span v-if="cageItem.catCount">猫:{{cageItem.catCount}}只</span>
										</div>
									</template>
								</div>
							</template>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleAddGrowthClick">确定</el-button>
		</div>
	</el-dialog>
</template>
<script>
	import {
		getShopRoom,
		cage,
		addGrowth,
		updateGrowth
	} from "@/api/purchaseApi.js"
	export default {
		props: {
			growthState: {
				default: false
			},
			shopId: {
				default: ''
			},
			petId: {
				default: ''
			},
			growthType:{
				default: null   //1是新增 2是修改
			},
			growthItem:{
				default: null   //单个成长记录数据
			}
		},
		data() {
			return {
				visible: true,
				form:{
					growthType:'1',  //成长记录类型
					date:'',  //日期时间
					text:'',  //内容
					status:'1',  //活体状态
					caption:'',  //说明
					record:'',  //饮食记录
					remark:'',  //备注
					imageUrl:[], //成长记录图片
				},
				intRoom:[],  //初始化笼子
				siteValue:[], //位置数据
				cageList:[],  //当前房间笼子列表
				roomList:[],  //房间列表
				roomId:'',  //房间id
			};
		},
		mounted() {
			//修改成长记录
			if(this.growthType == 2){
				console.log('跳转数据',this.growthItem)
				this.form.growthType = '2';
				this.form.date = new Date(Number(this.growthItem.operation_info.create.create_time)*1000);
				this.form.text = this.growthItem.titleContent;
				this.form.status = this.growthItem.petStatus.value;
				this.form.imageUrl = this.growthItem.avatarPic.split(',');
				this.form.caption = this.growthItem.statusRemark;
				this.form.record = this.growthItem.dietRemark;
				this.form.remark = this.growthItem.remark;
				let cage = this.growthItem.cageId.split(',');
				let cageList = [];
				for(let i = 0;i<cage.length;i++){
					cageList[i] = [this.growthItem.roomId,cage[i]]
				}
				this.siteValue = cageList;
			}
			this.getIntRoom()
			this.getPetsByShopList()
		},
		methods: {
			//新增成长记录
			handleAddGrowthClick(){
				if(this.form.text == ''){
					this.$message({
						message: '请输入内容',
						type: 'error'
					});
					return
				}
				if(this.form.imageUrl.length == 0){
					this.$message({
						message: '请添加图片',
						type: 'error'
					});
					return
				}
				if(this.form.caption == ''){
					this.$message({
						message: '请输入说明',
						type: 'error'
					});
					return
				}
				if(this.form.record == ''){
					this.$message({
						message: '请输入饮食记录',
						type: 'error'
					});
					return
				}
				if(this.siteValue.length == 0){
					this.$message({
						message: '请选择笼子位置',
						type: 'error'
					});
					return
				}
				
				let isCurrentTime = true;
				if(this.form.growthType == '1'){
					isCurrentTime = true;
				}else if(this.form.growthType == '2'){
					isCurrentTime = false;
				}
				let imgList = '';
				for(let j = 0; j<this.form.imageUrl.length;j++){
					imgList+=this.form.imageUrl[j]+','
				}
				imgList=imgList.substring(0,imgList.length-1);
				console.log(imgList)
				// 获取笼子信息
				let cageList = [];
				for(let i = 0;i<this.siteValue.length;i++){
					cageList.push({
						roomId:this.siteValue[i][0],
						cageId:this.siteValue[i][1]
					})
				}
				let params = {
					titleName:'',  //标题暂无
					petId:this.petId, //宠物id
					growthType:'0',  //成长类型
					titleContent:this.form.text,  //内容
					avatarPic:imgList,  //图片
					petStatus:this.form.status,  //活体状态
					statusRemark:this.form.caption,  //说明
					dietRemark:this.form.record,  //饮食记录
					shopId:this.shopId,  //门店id
					remark:this.form.remark,  //备注
					source:1,   //PC端添加
					cageInfos:cageList,  //笼子信息
					isCurrentTime: isCurrentTime,//是否当前记录
					beforeDate:this.form.date == ''?'':this.form.date.getTime()/1000  //过往时间
				}
				if(this.growthType == 1){
					addGrowth(params).then((res)=>{
						console.log('新增成长记录',res)
						if(res.code == 0){
							console.log(res)
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.$emit("closeClick", false);
						}
					})
				}else{
					params.id = this.growthItem._id;
					updateGrowth(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.$emit("closeClick", false);
						}
					})
				}
				
			},
			//切换房间
			handleRoomClick(item){
				// console.log(item)
				this.roomId = item.room_id;
				this.cageId = '';
				if(item.room_id == ''){
					this.cageList = this.roomList
				}else{
					let arr = [];
					arr[0] = item
					this.cageList = arr;
				}
			},
			//获取门店下当前笼子状态
			getPetsByShopList(){
				let pamars = {
					date:this.getStartEndData(new Date()).startStr,
					shopId:this.shopId
				}
				cage(pamars).then((res)=>{
					console.log('门店',res)
					if(res.code == 0){
						if(res.data.length == 0){
							this.roomList = res.data;
							this.cageList = res.data;
							this.allDogNum = 0;
							this.allCatNum = 0;
							return
						}
						res.data.unshift({
							room_id:'',
							room_name:'全部',
							cage_info:res.data
						})
						this.roomList = res.data;
						this.cageList = res.data;
						for(let i = 0; i<res.data.length;i++){
							if(res.data[i].room_id != ''){
								for(let j = 0;j<res.data[i].cage_info.length;j++){
									let catCount = 0;
									let dogCount = 0;
									for(let k = 0;k<res.data[i].cage_info[j].pet_list.length;k++){
										//循环获取数量
										if(res.data[i].cage_info[j].pet_list[k].pet_type.value == '1'){
											catCount = (catCount + 1);
											res.data[i].cat = catCount;
											res.data[i].cage_info[j].catCount = catCount;
										}else{
											dogCount = (dogCount + 1);
											res.data[i].dog = dogCount;
											res.data[i].cage_info[j].dogCount = dogCount;
										}
									}
								}
							}
						}
					}
				})
			},
			//获取开始时间和结束时间
			getStartEndData(nowDate) {
				// 获取时间
				let year = nowDate.getFullYear();
				let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1);
				let day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate();
				let startTime = `${year}-${month}-${day} 00:00:00`;
				let endTime = `${year}-${month}-${day} 23:59:59`;
				let startStr = new Date(startTime) / 1000;
				let endStr = new Date(endTime) / 1000;
				let formatDate = `${year}-${month}-${day}`;
				return {
					startStr: startStr,
					endStr: endStr,
					formatDate: formatDate
				}
			},
			//初始化笼子
			getIntRoom(){
				let params = {
					shopId:this.shopId
				}
				getShopRoom(params).then((res)=>{
					if(res.code == 0){
						console.log('初始化',res)
						this.intRoom = res.data;
					}
				})
			},
			//删除对应图片
			handleDeleteImgClick(index){
				console.log(index)
				this.form.imageUrl.splice(index,1)
			},
			//转移触发上传按钮
			handleUploadClick(){
				this.$refs.file.click()
			},
			//上传
			changeFile(e){
				var index= e.target.files[0].name.lastIndexOf(".");
				var ext = e.target.files[0].name.substr(index+1);
				var formData = new FormData();
				if(ext==='png'||ext==='jpg'||ext==='jpeg'){
					formData.append('img', e.target.files[0])
					this.$util.uploadImg_dir(formData,{dir:'uploadImg'}).then(data => {
						console.log(data)
						if (data.timestamp) {
							this.form.imageUrl.push(data.url);
						}
					})
				}else{
					this.$message({
						message: '只能上传jpg,png格式的文件',
						type: 'error'
					});
				}
			},
			//向父组件发射关闭弹框
			growthStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
		},
		watch: {
			// 监视状态发生改变
			growthState() {
				this.visible = this.growthState;
			},
		}
	};
</script>
<style lang="scss" scoped>
	.view {
		display: flex;

		.viewLeft {
			width: 400px;
			border-right: solid 1px #D4D4D4;
			.formView {
				display: flex;
				margin: 20px 0 10px 0;
				.imgView{
					flex: 1;
					.imgItem{
						position: relative;
						width: 80px; 
						height: 80px;
						margin-right:20px;
						margin-bottom: 10px;
						float: left;
						img{
							width: 100%;
							height: 100%;
						}
						.closeBtn{
							display: block;
							color: red;
							position: absolute;
							top: -10px;
							right: -10px;
							font-size: 20px;
							z-index: 5;
						}
					}
				}
			}
			.com{
				font-size: 14px;
				color: #2A2A2A;
				margin-bottom: 10px;
				line-height: 20px;
			}
		}

		.viewRight {
			flex: 1;
			padding-left: 20px;
			.siteName{
				font-size: 16px;
				color: #2A2A2A;
				font-weight: bold;
				line-height: 30px;
			}
			.roomView{
				height: 160px;
				overflow-x: hidden;
				overflow-y: scroll;
				cursor: pointer;
				.roomName{
					font-size: 16px;
					color: #2A2A2A;
					margin-bottom: 10px;
					font-weight: bold;
					line-height: 24px;
				}
				.room{
					width: 90px;
					line-height: 30px;
					box-sizing: border-box;
					border: 1px solid #979797;
					border-radius: 2px;
					text-align: center;
					font-size: 14px;
					color: #3A3A3A;
					float: left;
					margin-right: 14px;
					margin-bottom: 20px;
				}
				.roomActive{
					width: 90px;
					line-height: 30px;
					box-sizing: border-box;
					border: 1px solid #979797;
					border-radius: 2px;
					text-align: center;
					font-size: 14px;
					color: #fff;
					float: left;
					margin-right: 14px;
					margin-bottom: 20px;
					background: #1890FF;
				}
			}
			.roomView::-webkit-scrollbar {
				display: none;
			}
			.cageView{
				height: 300px;
				overflow-x: hidden;
				overflow-y: scroll;
				.cage{
					overflow: hidden;
					.cageTitle{
						font-size: 14px;
						font-weight: bold;
						// margin-bottom: 10px;
						padding-left: 14px;
						line-height: 30px;
					}
					.cageItem{
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						width: 80px;
						height: 40px;
						box-sizing: border-box;
						position: relative;
						border: solid 1px #979797;
						border-radius: 4px;
						margin-right: 5px;
						margin-bottom: 14px;
						float: left;
						font-size: 14px;
						.petNum{
							font-size: 12px;
							margin-top: 4px;
						}
					}
				}
			}
			.cageView::-webkit-scrollbar {
				display: none;
			}
		}
	}
</style>
